import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const LandingPage = lazyRouteComponent(() => import('./pages/home'));

const SellPage = lazyRouteComponent(() => import('./pages/sell'));

export const getRoutes = (): Route[] => [
  {
    page: SellPage,
    path: ROUTE_PATHS.HOW_TO_SELL,
    title: 'Venda na NexoTCG',
    hidden: true,
    public: true,
    allowUnverified: true,
  },
  {
    page: LandingPage,
    path: ROUTE_PATHS.HOME,
    title: 'NexoTCG',
    hidden: true,
    public: true,
  },
];
